'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var classname = require('@bem-react/classname');
var classnames = require('@bem-react/classnames');

function withBemMod(blockName, mod, enhance) {
    var entity;
    var entityClassName;
    var modNames;
    return function WithBemMod(WrappedComponent) {
        // Use cache to prevent create new component when props are changed.
        var ModifiedComponent;
        var modifierClassName;
        entity = entity || classname.cn(blockName);
        entityClassName = entityClassName || entity();
        function BemMod(props) {
            modNames = modNames || Object.keys(mod);
            // TODO: For performance can rewrite `every` to `for (;;)`.
            var isModifierMatched = modNames.every(function (key) {
                var modValue = mod[key];
                var propValue = props[key];
                return modValue === propValue || (modValue === '*' && Boolean(propValue));
            });
            if (isModifierMatched) {
                var modifiers = modNames.reduce(function (acc, key) {
                    if (mod[key] !== '*')
                        acc[key] = mod[key];
                    return acc;
                }, {});
                modifierClassName = modifierClassName || entity(modifiers);
                var nextProps = Object.assign({}, props);
                nextProps.className = classnames.classnames(modifierClassName, props.className)
                    // Replace first entityClassName for remove duplcates from className.
                    .replace(entityClassName + " ", '');
                if (enhance !== undefined) {
                    if (ModifiedComponent === undefined) {
                        ModifiedComponent = enhance(WrappedComponent);
                        {
                            setDisplayName(ModifiedComponent, {
                                wrapper: 'WithBemModEnhance',
                                wrapped: WrappedComponent,
                            });
                        }
                    }
                }
                else {
                    ModifiedComponent = WrappedComponent;
                }
                // Use createElement instead of jsx to avoid __assign from tslib.
                return react.createElement(ModifiedComponent, nextProps);
            }
            // Use createElement instead of jsx to avoid __assign from tslib.
            return react.createElement(WrappedComponent, props);
        }
        {
            setDisplayName(BemMod, {
                wrapper: WithBemMod,
                wrapped: entityClassName,
                value: mod,
            });
        }
        return BemMod;
    };
}
function getDisplayName(Component) {
    return typeof Component === 'string'
        ? Component
        : Component.displayName || Component.name || 'Component';
}
function setDisplayName(Component, meta) {
    var wrapperName = getDisplayName(meta.wrapper);
    var wrappedName = getDisplayName(meta.wrapped);
    Component.displayName = wrapperName + "(" + wrappedName + ")";
    if (meta.value !== undefined) {
        var value = JSON.stringify(meta.value)
            .replace(/\{|\}|\"|\[|\]/g, '')
            .replace(/,/g, ' | ');
        Component.displayName += "[" + value + "]";
    }
}
/* tslint:enable:max-line-length */
/**
 * @param funcs higher order components
 *
 * @example
 * ```ts
 * import { compose } from '@bem-react/core';
 *
 * const Enhanced = compose(
 *     withBemMod('Component', { size: 's' }),
 *     withBemMod('Component', { theme: 'normal' }),
 * )(Component);
 * ```
 */
function compose() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return funcs.reduce(function (a, b) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return a(b.apply(void 0, args));
    }; }, function (arg) { return arg; });
}
/* tslint:enable:max-line-length */
function composeU() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return compose.apply(void 0, args);
}

exports.compose = compose;
exports.composeU = composeU;
exports.withBemMod = withBemMod;
